import { useLanguage } from '@/contexts/LanguageContext';
import type { ServiceFaqItem } from '@/lib/serviceCatalog';

type FAQSectionProps = {
  title?: string;
  items: ServiceFaqItem[];
};

const FAQSection = ({ title, items }: FAQSectionProps) => {
  const { lang } = useLanguage();

  if (!items.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="font-display text-3xl font-bold text-foreground mb-8">
        {title || (lang === 'tr' ? 'Sık Sorulan Sorular' : 'Frequently Asked Questions')}
      </h2>

      <div className="space-y-4">
        {items.map((item, index) => (
          <details key={`${item.question.en}-${index}`} className="group rounded-xl border border-border/70 px-6 py-4 bg-card/50">
            <summary className="font-display text-lg text-foreground cursor-pointer list-none flex items-start justify-between gap-4">
              <span>{item.question[lang]}</span>
              <span className="text-muted-foreground group-open:rotate-45 transition-transform">+</span>
            </summary>
            <p className="font-body text-sm leading-relaxed text-muted-foreground mt-4 pr-8">
              {item.answer[lang]}
            </p>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
